import { useEffect } from "react";
import { appConfig } from "../config/appConfig";
import type { AuthUser } from "../lib/auth";

declare global {
  interface Window {
    markerConfig?: {
      project: string;
      source: string;
    };
    Marker?: {
      setReporter?: (reporter: { email?: string; fullName?: string }) => void;
      clearReporter?: () => void;
    };
  }
}

type MarkerIoLoaderProps = {
  user: AuthUser;
};

export function MarkerIoLoader({ user }: MarkerIoLoaderProps) {
  useEffect(() => {
    if (appConfig.environment !== "test" || !appConfig.markerProjectId) return;

    window.markerConfig = {
      project: appConfig.markerProjectId,
      source: "snippet"
    };

    if (!window.Marker) {
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://edge.marker.io/latest/shim.js";
      document.head.appendChild(script);
    }
  }, []);

  useEffect(() => {
    if (appConfig.environment !== "test" || !window.Marker?.setReporter) return;

    window.Marker.setReporter({
      email: user.email,
      fullName: [user.firstName, user.lastName].filter(Boolean).join(" ") || user.email
    });

    return () => {
      window.Marker?.clearReporter?.();
    };
  }, [user.email, user.firstName, user.lastName]);

  return null;
}
